<template>
  <LayoutDefault :title="title">
    <b-card v-if="auditsByModelId.length > 0 || loading" body-class="p-0" class="mt-3 d-flex flex-column p-0">
      <Table class="flex-fill"
             :isLoading="loading"
             :items="auditsByModelId" />
      <Paginator v-if="paginator.total > paginator.per_page"
                 :page="paginator.page"
                 :per-page="paginator.per_page"
                 :total="paginator.total"
                 @change="paginate"/>
    </b-card>
    <EmptyData v-else title=" "/>    
  </LayoutDefault>
</template>

<script>
import EmptyData from "@/components/EmptyData";
import Paginator from "@/components/Paginator";
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from 'vuex';
import Table from "./Table";

export default {
  name: "AuditLogs",
  components: {
    EmptyData,
    Table,
    Paginator,
    LayoutDefault
  },
  computed: {
    ...mapGetters({
      audits: 'audit/allByModelId',
      loading: 'audit/isLoading',
      paginator: 'audit/pagination'
    }),
    auditsByModelId() {
      return this.audits ?? [];
    },
    title() {
      return this.$t('logs.listagem.titulo_pagina') + ' - ID: ' + this.modelId;
    }
  },
  data() {
    return {
      modelId: null
    }
  },
  methods: {
    ...mapActions([
      'audit/listAllByModelId'
    ]),
    search() {
      this.$store.commit(
          'audit/setPagination',
          {
            page: this.paginator.page,
            per_page: this.paginator.per_page            
          },
          {root: true}
      )

      this.$store.commit('audit/setAllByModelId', [], {root: true})
      this['audit/listAllByModelId'](this.modelId)
    },
    paginate(pagination) {
      this.$store.commit('audit/setPagination', pagination, {root: true})
      this.search()
    },
  },
  mounted() {
    this.modelId = this.$route.params.id;
    this.paginate({page: 1, per_page: 10, total: 0})
  }
}
</script>

<style lang="scss" scoped>
.mx-datepicker-range,
.mx-datepicker {
  width: 100% !important;
}
</style>
